import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
import session from '../../../../share/session';
import error from '../../../../common/nodejs/errors';
import { REQUEST_STATUS_COMPLETED } from '../../../../../../share/src/util/api/polling';
import { PHASE, ADJUSTMENT_STATUS } from './constants';
import { read } from './read';
import { terminate } from './terminate';

/** 
 * ルーチン実行・結果確認
 * @param {object} self this インスタンス
 */
export async function execute(self) {
  try {
    self.isLoading = true;
    // バックエンドAPI POST,GET
    const token = session.getToken();
    const response = await individualWorkSupportUtil.pollingWspApi(
      self,
      self.netAppId,
      self.systemId,
      self.workSupportId,
      {
        id_token: token.id_token,
        type: 'execute',
      },
      // エラー発生のコールバックを実装
      async (errorType) => { errorType; await self.showUnexpectedError(); },
      // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      async (result) => { await self.validateErrorResult(result); },
      // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      async (result) => { await self.validateErrorResult(result); },
    );

    if (!response) {
      // pollingWspApiはエラーコールバックの終了を待たずnullを返す
      // 非同期処理を含んでいるshowUnexpectedErrorが呼ばれた場合、スピナー消えてしまうためPromiseの解決を待つ
      if (self.exitPromise) await self.exitPromise;
      return;
    }

    // 正常コールバック
    if (response.data?.status === REQUEST_STATUS_COMPLETED) {
      // 取得した調整結果（adjustment_status）を判定
      self.adjustmentStatus = response.data.user_data?.adjustment_status;
      switch (self.adjustmentStatus) {
        case ADJUSTMENT_STATUS.ADJUSTMENT_OK:
        case ADJUSTMENT_STATUS.ADJUSTMENT_NG:
          // 軸調整OK、軸調整NGの場合
          // 取得した水平結果（horizontal_status）、垂直結果（vertical_status）を保持する
          self.horizontalStatus = response.data.user_data?.horizontal_status;
          self.verticalStatus = response.data.user_data?.vertical_status;
          // データ読出し処理のAPI実行
          await read(self, false);
          break;
        case ADJUSTMENT_STATUS.ADJUSTMENT_NO:
          // リフレクタ無しの場合
          // Terminate処理のAPI実行
          await terminate(self);
          // リフレクタ無し画面に遷移
          self.phase = PHASE.ADJUSTMENT_NO;
          break;
        default:
          break;
      }
    } else {
      // 発生日時読み出し失敗の場合
      switch (response.data?.async_code) {
        case error.WSP_155_EXECUTE_ERROR:
          // エラー処理として保持
          self.adjustmentStatus = ADJUSTMENT_STATUS.ADJUSTMENT_FAILED;
          // データ読出し処理のAPI実行
          await read(self, true);
          break;
        default:
          // 共通エラー
          await self.showUnexpectedError();
          break;
        }
    }
  } finally {
    self.isLoading = false;
  }
}